import axios from 'axios';
// import { objToParams } from 'helpers';
import { xpertly_api_root } from './setup';

export function analyse(data) {
  return axios.post(`${xpertly_api_root}/ai/analyse`, data);
}

export function checkRequest(data) {
  return axios.post(`${xpertly_api_root}/ai/check-request`, data);
}

export function BERT(query) {
  return axios.post(`${xpertly_api_root}/ai/question-answering`, query);
}

export function generateWorkflow(conversation) {
  return axios.post(`${xpertly_api_root}/ai/generate-workflow`, conversation);
}

export function getConversation(conversationId) {
  return axios.get(`${xpertly_api_root}/ai/conversation/${conversationId}`);
}

export function assistant(tenantId, taskType, messages) {
  return axios.post(`${xpertly_api_root}/tenants/${tenantId}/assistant/${taskType}`, { messages })
}